import React from 'react';
import PropTypes from 'prop-types';

const HeaderSection = ({ labelHeader, labelTitle }) => (
  <div className="col-xs-12">
    <div className="col-xs-12">
      <h3 className="micuenta-title">
        <strong>{labelHeader}</strong>
      </h3>
      <p>{labelTitle}</p>
    </div>
  </div>
);

HeaderSection.propTypes = {
  labelHeader: PropTypes.string,
  labelTitle: PropTypes.string,
};

export default HeaderSection;
